import React from 'react'
import { observer, inject } from 'mobx-react'

import SmallButtonList from '../../../generic/SmallButtonList'

const UsersTableActions = inject('configUsersStore')(observer(props => {
  const { configUsersStore, user } = props
  const actions = [{
    text: 'Editar',
    onClick: () => {
      configUsersStore.setSelectedUser(user)
      configUsersStore.openEditModal()
    }
  }]
  return (
    <SmallButtonList buttons={actions} />
  )
}))

export default UsersTableActions



// WEBPACK FOOTER //
// ./src/components/dashboard/config/users/UsersTableActions.js